








import { Component, Prop, Vue } from "vue-property-decorator";
import { mapGetters } from "vuex";

@Component({
  computed: mapGetters([
    "numCompletedChallengeResultsForCampaign",
    "numTotalChallengesForCampaign",
  ]),
})
export default class StatisticsCard extends Vue {
  @Prop({ required: true }) private readonly id!: number;
}
